export default __webpack_public_path__ + "img/Process.33b290c.gif";